var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('slider',{attrs:{"sliderData":_vm.sliderData}}),_vm._v(" "),_c('div',{staticClass:"wutuDiv w1200 flexDiv"},[_c('xxggList',{attrs:{"xxggList":_vm.xxggList,"moreLink":"/list.html?HType=2&CId=5498"}}),_vm._v(" "),_c('jxglList',{attrs:{"jxglList":_vm.jxglList,"moreLink":"/list.html?HType=2&CId=5503"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ccb6dd6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = null
// module chunks = 